import { render, staticRenderFns } from "./tasksViewGoods.vue?vue&type=template&id=cfe3833a&"
import script from "./tasksViewGoods.vue?vue&type=script&lang=js&"
export * from "./tasksViewGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports